export const OPEN_STAR_MAP = 'OPEN_STAR_MAP'
export const GET_STAR_MAP_DETAIL = 'GET_STAR_MAP_DETAIL'
export const SET_STAR_DATA = 'SET_START_DATA'
export const SAVE_STAR_MAP_ENV_DEPLOY = 'SAVE_STAR_MAP_ENV_DEPLOY'
export const GET_MIP_ENV_LIST = 'GET_MIP_ENV_LIST'
export const GET_MIP_API_LIST = 'GET_MIP_API_LIST'
export const SET_MIP_API_LIST = 'SET_MIP_API_LIST'
export const GET_MIP_API_DETAIL = 'GET_MIP_API_DETAIL'
export const GET_MIP_API_HISTORY_DETAIL = 'GET_MIP_API_HISTORY_DETAIL'
export const ADD_ENV_MAP = 'ADD_ENV_MAP'
export const DELETE_ENV_MAP = 'DELETE_ENV_MAP'
export const GET_BUSINESS_ENV_LIST_BY_CATEGORY = 'GET_BUSINESS_ENV_LIST_BY_CATEGORY'
export const GET_ENV_BINDING_LIST = 'GET_ENV_BINDING_LIST'
export const GET_STAR_MAP_BINDING_DETAIL = 'GET_STAR_MAP_BINDING_DETAIL'
export const UPDATE_STAR_MAP_INFO = 'UPDATE_STAR_MAP_INFO'
export const UPDATE_STAR_MIP_API = 'UPDATE_STAR_MIP_API'
export const UPDATE_STAR_MIP_API_LIST = 'UPDATE_STAR_MIP_API_LIST'
